import { render, staticRenderFns } from "./DanhSachQuyenTrongApp.vue?vue&type=template&id=4ae13475&"
import script from "./DanhSachQuyenTrongApp.vue?vue&type=script&lang=js&"
export * from "./DanhSachQuyenTrongApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports